import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RegulatoryOffering from "@/pages/RegulatoryOffering";

export const Route = createFileRoute("/es/servicios/regulatory-affairs/estrategia-de-regulatory-affairs-en-la-industria-farmacéutica")({
  head: () => buildRouteHead("/es/servicios/regulatory-affairs/estrategia-de-regulatory-affairs-en-la-industria-farmacéutica"),
  component: RegulatoryOffering,
});

